(function() {
    'use strict';

    angular
        .module('uniromaLandingApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'chart.js',
            'ui.tree',
            'ui.ace',
            'ui.codemirror',
            'ui.validate',
            'frapontillo.bootstrap-switch',
            'vcRecaptcha',
            'angular-notification-icons'
        ])
        .config(function() {
        	angular.lowercase = angular.$$lowercase;  
        })
        .config(["$qProvider", function ($qProvider) {
            $qProvider.errorOnUnhandledRejections(false);
        }])
        .config(["$locationProvider", function ($locationProvider) {
        	$locationProvider.hashPrefix("");
        }])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$rootScope', '$q', '$location', '$state', 'Principal', 'Auth', 'UserContacts' ];

    function run(stateHandler, translationHandler, $rootScope, $q, $location, $state, Principal, Auth, UserContacts) {
        stateHandler.initialize();
        translationHandler.initialize();
        
        var USER_SETTINGS_STATE = 'settings';
        var HOME_STATE = 'home';
        HOME_STATE = true; // FIXME: questo risolve il fatto che non si possa accedere a reset/request da non autenticati - togliere e trovare un'altra soluzione quando verrà richiesto di mostrare solo la HOME agli utenti presenti solo su Domino
        
        $rootScope.$on("$locationChangeStart", function(event, next, current) { 
           console.log("location change start detected"); 
           var canChangePromise = canChange(event, next, current);
           canChangePromise.then(function( locationChangeAllowed ) {
        	   if ( locationChangeAllowed !== true ) {
        		   console.log("preventing change");
        		   $state.go( locationChangeAllowed || USER_SETTINGS_STATE );
               } 
           }, function() {
        	   $state.go( USER_SETTINGS_STATE );
           });
           
        });
        
        $rootScope.$on("routeChangeStart", function(event, next, current) { 
            console.log("route change start detected"); 
            var canChangePromise = canChange(event, next, current);
            canChangePromise.then(function( routeChangeAllowed ) {
         	   if ( routeChangeAllowed !== true ) {
         		   console.log("preventing change");
             	   $state.go( routeChangeAllowed || USER_SETTINGS_STATE );
               } 
            }, function() {
         	   $state.go( USER_SETTINGS_STATE );
            });
            
         });
        
        /*
         * controlla se l'utente è autenticato e ha impostato la mail privata nei contatti
         */
        function canChange(event, next, current) {
        	var deferred = $q.defer();
        	
	        if ( Principal.isAuthenticated() ) {
	        	Principal.identity().then(function(account) {
	        		if (!account || !account.login || account.login.indexOf("@") >= 0) {
		            	deferred.resolve(true);
	        		} else {
			    		UserContacts.get().$promise
						.then(getContactsThen)
						.catch(getContactsCatch);
	        		}
	            }).catch(function() {
	            	deferred.resolve(HOME_STATE);
	            });
	        } else {
	        	deferred.resolve(HOME_STATE);
	        }
	        	        
	        return deferred.promise;
	        

	        function getContactsThen (contacts) {
	        	var email = (contacts !== undefined ? contacts.email : null);
	        	var resolved = (email !== null ? true : false);
	        	deferred.resolve( resolved );
	        }

		    function getContactsCatch (err) {
		    	if (console && console.log) console.log("WARNING: error getting personal contacts: ", err);
		        deferred.resolve(true);
		    }
		        
        }
      
        
    }
    
   
    
    
    
})();
